import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { EmailQueryInterface } from '@zaoblako/shared/common/dtos/email-query.dto';
import type { ProfileChangePasswordInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-change-password.dto';
import type { ProfileFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-find.dto';
import type { ProfileFlatListQueryInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-flat-list-query.dto';
import type { ProfileListPageInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-list-page.dto';
import type { ProfileLoginFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-login-find.dto';
import type { ProfileLoginFormInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-login-form.dto';
import type { ProfilePageListQueryInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-page-list-query.dto';
import type { ProfileTestEmailFindInterface } from '@zaoblako/shared/modules/security/dtos/profile/profile-test-email-find.dto';
import type { AvailableTenantsInterface } from '@zaoblako/shared/modules/saas/dtos/available-tenants.dto';

import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends BaseService {
  protected baseUrl = '/basis/security/profile';

  public check(): Observable<ProfileLoginFindInterface> {
    return this.http.get<ProfileLoginFindInterface>(`${this.baseUrl}/check`);
  }

  public login(login: ProfileLoginFormInterface): Observable<ProfileLoginFindInterface> {
    return this.http.post<ProfileLoginFindInterface>(`${this.baseUrl}/login`, login);
  }

  public changePassword(body: ProfileChangePasswordInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/change-password`, body);
  }

  public findManyFlat(params?: ProfileFlatListQueryInterface): Observable<ProfileFindInterface[]> {
    return this.http.get<ProfileFindInterface[]>(`${this.baseUrl}/flat`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public findManyPage(params?: ProfilePageListQueryInterface): Observable<ProfileListPageInterface> {
    return this.http.get<ProfileListPageInterface>(`${this.baseUrl}/page`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public testEmail(email: EmailQueryInterface): Observable<ProfileTestEmailFindInterface> {
    return this.http.get<ProfileTestEmailFindInterface>(`${this.baseUrl}/test-email`, {
      params: this.objectToHttpParams(email)
    });
  }

  public resetPassword(email: EmailQueryInterface): Observable<null> {
    return this.http.post<null>(`${this.baseUrl}/reset-password`, email);
  }

  public leaveTelegramChat(): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/leave-telegram-chat`);
  }

  public hasProfileAccessToAdminTenant(queryParams: EmailQueryInterface): Observable<{ access: boolean }> {
    return this.http.get<{ access: boolean }>(`${this.baseUrl}/check-access-by-email`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getAvailableTenants(): Observable<AvailableTenantsInterface> {
    return this.http.get<AvailableTenantsInterface>(`${this.baseUrl}/available-tenants`);
  }
}
